import { forEach, includes } from 'lodash/collection';
import { isArray } from 'lodash/lang';

import { ALL } from '../../../../../constants/accessToPages';

import { MenuItems } from './MenuConfig';

export function checkRoleHasAccess(menuCode, user) {
  return includes(user?.accessToPages, menuCode);
}

export function getFilteredMenuItems(user, featureMap) {
  return MenuItems.map(MenuItem => {
    return filterSubItems(MenuItem, user, featureMap);
  }).filter(e => e);
}

function filterSubItems(menuItem, user, featureMap) {
  if (accessAllowed(user, menuItem.access) && featureEnabled(menuItem.feature, featureMap)) {
    if (menuItem.subItems) {
      menuItem.subItems = menuItem.subItems
        .map(subItem => {
          return filterSubItems(subItem, user, featureMap);
        })
        .filter(e => e);
    }
    return menuItem;
  }
  return null;
}

function featureEnabled(feature, featureMap) {
  return !feature || !featureMap || featureMap[feature];
}

export function accessAllowed(user, access) {
  if (isArray(access)) {
    return access.some(e => includes(user?.accessToPages, e));
  }
  if (access) {
    return includes(user?.accessToPages, access);
  }
  return access === ALL;
}

export function isActive(item, active) {
  return item.subItems.flatMap(el => getPath(el)).includes(active);
}

function getPath(element) {
  if (element.subItems) {
    return element.subItems.flatMap(e => getPath(e));
  } else {
    return element.path;
  }
}

export const NAV_MENU = 'NAVIGATION_MENU';

export function withoutSpaces(str) {
  return str.replace(/\s/g, '');
}

/*TODO: need to investigate and find better solution*/
export function setDefaultFilterItemsToStorage() {
  setItemsToStorage({
    fromMenu: true,
    Patient_StudyName: { id: 'ALL', name: 'All Studies' },
    Patient_SiteName: { id: 'ALL', name: 'All Sites' },
    Patient_Status: { id: 'ALL', name: 'All Status' }
  });
}

function setItemsToStorage(items) {
  forEach(items, (v, k) => {
    localStorage.setItem(k, JSON.stringify(v));
  });
}
